module.exports = __webpack_public_path__ + "static/media/fcloader.ea69c9ac.gif";